<template lang="pug">
    section#conteudo
        .wrapper
            h2 {{noticia.titulo}}
            h3 Notícia - {{noticia.date}}
            .conteudo(v-html="noticia.conteudo")
</template>

<script>
export default {
    name: "section-conteudo",
    props: {
        noticia: Object,
    }
}
</script>

<style lang="stylus" scoped src="./Conteudo.styl"></style>